import React from "react";
import CodeWars from "../../components/RoleBased/CodeWars";
import { connect } from "react-redux";

const CodeWarsContainer = props => <CodeWars {...props} />;

const mapState = (state, props) => ({
    group: props.match.params.group
});

const actions = (dispatch, props) => ({
});

export default connect(mapState, actions)(CodeWarsContainer);